import { isOrderAgentPlatform, normalizePlatformKey } from "./platformLogos";

/**
 * Localized display name for a platform / app type string from the API.
 */
export function getLocalizedPlatformName(value, t) {
  const raw = String(value || "").trim();
  if (!raw) return "";
  const up = normalizePlatformKey(raw);

  if (up.includes("NINJA") && up.includes("STAGING")) {
    return t("platformName.NINJA_STAGING");
  }
  if (up.includes("JAHEZ")) return t("platformName.JAHEZ");
  if (up.includes("KEETA")) return t("platformName.KEETA");
  if (up.includes("CHEFZ")) return t("platformName.THE_CHEFZ");
  if (up.includes("NINJA")) return t("platformName.NINJA");
  if (isOrderAgentPlatform(raw)) return t("Order Agent");
  if (up.includes("DIGITAL CATALOG")) return t("Digital Catalog");
  if (up.includes("TRACK HUB") || up.includes("TRACKHUB")) return t("platformName.TRACK_HUB");
  if (up.includes("FOODICS")) return t("Foodics");
  if (up.includes("TAB SENSE") || up.includes("TABSENSE")) {
    return t("posTypeTabSense");
  }
  if (up.includes("NOON")) return t("Noon", { defaultValue: "Noon" });

  const cleaned = raw.replace(/_/g, " ").replace(/\s+/g, " ").trim();
  return cleaned
    .split(" ")
    .map((w) => (w ? w[0].toUpperCase() + w.slice(1).toLowerCase() : ""))
    .join(" ");
}
